import { IActionContext } from "@msdyn365-commerce/core";
import { callActionOrExecute, DataServiceQuery, SalesOrder, IDataServiceRequest } from "@msdyn365-commerce/retail-proxy";
//import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';

function updateTransactionCustomerQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function createUpdateTransactionCustomerInput(salesOrder: SalesOrder): IDataServiceRequest {
    const query = updateTransactionCustomerQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateTransactionCustomer',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            salesOrder: salesOrder
        }
    );
}

export async function updateTransactionCustomerAsync(context: IActionContext,  salesOrder: SalesOrder): Promise<boolean> {
    const request = createUpdateTransactionCustomerInput(salesOrder);
    return callActionOrExecute<boolean>(request, context);
}
